class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    document.dispatchEvent(new CustomEvent('yotpo:toggle'));
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    setTimeout(() => {
      window._swat.initializeActionButtons('cart-drawer-items');
    }, 1000);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.dispatchEvent(new CustomEvent('yotpo:toggle'));
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      const cartDrawerAfterPay = document.querySelector('.cart__payment-afterpay');
      if (!cartDrawerAfterPay) return;
      cartDrawerAfterPay.addEventListener('click', () => {
        const squarePlacement = document.querySelector('square-placement');
        const shadowRoot = squarePlacement.shadowRoot;
        const afterPayLogoLink = shadowRoot.querySelector('#logo-link');
        afterPayLogoLink.click();
      });
    }, 300);

    // Handle threshold
    const ausFullTracker = document.querySelector('.drawer__thresholds-aus--full-tracker');
    const expressThresholdWrapper = document.querySelector('.drawer__thresholds-express__wrapper');
    const freeShipNotify = document.querySelector('.drawer__free-ship-notify');
    setTimeout(() => {
      if (ausFullTracker) {
        ausFullTracker.classList.add('aus-progress-hide');
        localStorage.setItem("aus-full-tracker", "enable");
      } else {
        localStorage.removeItem("aus-full-tracker");
      }

      if (expressThresholdWrapper) {
        expressThresholdWrapper?.classList.add('express-progress-show');
        freeShipNotify?.classList.add('drawer__free-ship-notify--show');
        localStorage.setItem("express-progress-tracker", "enable");
      } else {
        localStorage.removeItem("express-progress-tracker");
      }

      if (localStorage.getItem("aus-full-tracker") == "enable") {
        ausFullTracker?.classList.add("aus-progress-display-none");
      } else {
        ausFullTracker?.classList.remove("aus-progress-display-none");
      }

      if (localStorage.getItem("express-progress-tracker") == "enable") {
        expressThresholdWrapper?.classList.add("express-progress-display-block");
        freeShipNotify?.classList.add("drawer__free-ship-notify--display-block");
      } else {
        expressThresholdWrapper?.classList.remove("express-progress-display-block");
        freeShipNotify?.classList.remove("drawer__free-ship-notify--display-block");
      }
    }, 2000);

    if (localStorage.getItem("aus-full-tracker") == "enable") {
      ausFullTracker?.classList.add("aus-progress-display-none");
    } else {
      ausFullTracker?.classList.remove("aus-progress-display-none");
    }

    if (localStorage.getItem("express-progress-tracker") == "enable") {
      expressThresholdWrapper?.classList.add("express-progress-display-block");
      freeShipNotify?.classList.add("drawer__free-ship-notify--display-block");
    } else {
      expressThresholdWrapper?.classList.remove("express-progress-display-block");
      freeShipNotify?.classList.remove("drawer__free-ship-notify--display-block");
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
